// Titles and descriptions of the finished, indexable release pages.
// KEEP IN SYNC with PAGES in deploy/release/build-static.mjs, which writes the
// same values into each page's static head.
// Copy rules: no em or en dashes, British English, 140-160 character
// descriptions, one plate-count figure (80 million, the verified homepage band).

export interface PageMeta {
  title: string;
  description: string;
}

export const HOME_DESCRIPTION =
  'Compare private number plate prices from UK dealers, the DVLA and private sellers. Search over 80 million registrations and see any plate on your car.';

export const PAGE_META: { [url: string]: PageMeta } = {
  '/': {
    title: 'PlateX | Compare Private Number Plate Prices UK',
    description: HOME_DESCRIPTION,
  },
  '/plates': {
    title: 'Private Number Plates for Sale | Compare Prices | PlateX',
    description:
      'Browse private number plates by type: dateless, current style, initials, names, number 1s and plates under £200, with prices compared across UK sellers.',
  },
  '/plates/current-style': {
    title: 'Current Style Number Plates for Sale | Compare Prices | PlateX',
    description:
      'Current style number plates from every registration series since 2001. Pick a series, compare prices from UK dealers and the DVLA, and see plates on your car.',
  },
  '/plates/dateless': {
    title: 'Dateless Number Plates for Sale | Compare Prices | PlateX',
    description:
      'Dateless number plates carry no age identifier, so they suit any vehicle. Browse the oldest UK registrations and compare prices across UK sellers.',
  },
  '/plates/initials': {
    title: 'Initials Number Plates for Sale | Compare Prices | PlateX',
    description:
      'Find a private number plate with your initials. Search one, two or three letter initials and compare prices from UK dealers, the DVLA and private sellers.',
  },
  // {initials} is filled (upper case) by route-data-service; once per string.
  '/plates/initials/{initials}': {
    title: '{initials} Number Plates | Browse & Compare Prices | PlateX',
    description:
      'Private number plates with the initials {initials}: browse registrations and compare prices from UK dealers, the DVLA and private sellers in one place.',
  },
  '/plates/name-plates': {
    title: 'Name Number Plates for Sale | Compare Prices | PlateX',
    description:
      'Private number plates that spell a name, from short dateless names to current style readings. Browse name plates and compare prices across UK sellers.',
  },
  '/plates/number-1': {
    title: 'Number 1 Plates for Sale | Compare Prices | PlateX',
    description:
      'Number 1 registrations are among the most sought after UK private plates. Browse number 1 plates of every format and compare prices across UK sellers.',
  },
  '/plates/budget/under-200': {
    title: 'Number Plates Under £200 | Compare Cheap Private Plates | PlateX',
    description:
      'Cheap private number plates under £200 from across the UK market in one place. Compare prices from dealers and the DVLA and find an affordable plate.',
  },
  '/plate-viewer': {
    title: 'Number Plate Viewer | See Any Reg on Any Car | PlateX',
    description:
      'Free number plate viewer: see any registration on a huge choice of cars, from Fiat to Ferrari. Preview private plates before you buy, then download and share.',
  },
  '/byo-search': {
    title: 'Build Your Own Private Number Plate | PlateX',
    description:
      'Build your own private number plate: enter the letters and numbers you want and see which registrations are available, with prices compared across UK sellers.',
  },
  '/about': {
    title: 'About PlateX | UK Private Number Plate Price Comparison',
    description:
      'PlateX brings the UK private number plate market into one place: compare prices from dealers, the DVLA and private sellers, and see any plate on your car.',
  },
  '/privacy-policy': {
    title: 'Privacy Policy | PlateX',
    description:
      'How PlateX collects, uses and protects your personal data when you search, compare and save private number plates, and how to exercise your data rights.',
  },
  '/data-deletion': {
    title: 'Data Deletion | PlateX',
    description:
      'How to ask PlateX to delete your account and personal data: email info@platex.co.uk, see what we delete or anonymise, what we may keep and when we respond.',
  },
};
